<template>
  <div class="jtcy">
    <div>
     <!-- <div class="tj" @click="tc">
        <van-icon name="add-o" color="#49A3F1" size="20px" class="cvb" />
        <span class="ziti1">添加家庭成员</span>

        <van-overlay :show="show" @click="show = false" />
      </div> -->

      <div class="chengyuan" v-for="(item,index) in chengyuan" :key="index">
        <div class="user">
          <span>
            姓名：
            <span class="asd12">{{item.name}}</span>
          </span>
        </div>

        <div class="guanxi">
          <span>
            与户主关系：
            <span class="asd12">{{item.relationship}}</span>
          </span>
        </div>

        <div class="age">
          <span>
            年龄：
            <span class="asd12">{{item.age}}</span>
          </span>
        </div>

        <div class="sj">
          <span>
            手机号：
            <span class="asd12">{{item.mobile}}</span>
          </span>
        </div>

      <!--  <button class="anniu" @click="deletePerson(index)">
          <img
            src="../../assets/icon/sscc.png"
            alt
            width="10px"
            style="  float: left;margin-top:3px;"
          />删除
        </button> -->
      </div>

      <div class="mmm" v-show="mmmm">
        <div class="tanc">
          <div class="gb" @click="change">
            <van-icon name="cross" />
          </div>
          <span class="bbt">添加家庭成员</span>
          <van-form @submit="onSubmit">
            <van-field
              v-model="username"
              name="姓名"
              label="姓名"
              placeholder="姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />

            <van-field
              v-model="age"
              name="年龄"
              label="年龄"
              placeholder="年龄"
              :rules="[{ required: true, message: '请填写年龄' }]"
            />

            <van-field
              readonly
              clickable
              label="关系"
              :value="value"
              placeholder="关系"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
              />
            </van-popup>

            <van-field
              v-model="sj"
              name="手机号"
              label="手机号"
              placeholder="手机号"
              :rules="[{ required: true, message: '请填写手机号' }]"
            />
          </van-form>
          <div class="btn" @click="add">
          <button class="btn1" >确定</button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { Icon, Button, Overlay, Toast, Picker } from "vant";
Vue.use(Icon).use(Button).use(Overlay).use(Toast).use(Picker);
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      selected: "A",
      mmmm: false,
      password: "",
      show: false,
      username: "",
      age: "",
      value: '',
      sj:'',
      showPicker: false,
      columns: ['儿子', '女儿', '孙子', '老婆', '老公', '爸爸', '妈妈', '爷爷'],
      options: [
        { text: "One", value: "One" },
        { text: "Two", value: "Two" },
        { text: "Three", value: "Three" },
      ],
      chengyuan: [
       /* {
          name: "冰红茶",
          gx: "父子",
          age: "26岁",
          sj: "18888888888",
        }, */
      ],
    };
  },
  computed: {
  	...mapState(['userInfo','identity','houseId']),
  },
   mounted() {
	   this.$axios.get('/api/v1/cohabitant/house/'+this.houseId).then(res=>{
		   this.chengyuan=res;
	   })
   },
  methods: {
    tc: function () {
      this.mmmm = true;
      this.show = true;
    },
    change: function () {
      this.mmmm = false;
      this.show = false;
    },
    deletePerson: function (index) {
      // 删一个数组元素
      this.chengyuan.splice(index, 1);
    },

    onSubmit(values) {
      console.log("submit", values);
    },
    add: function () {
     
      var obj = {
        name: this.username,
        age: this.age,
        gx: this.value,
        sj: this.sj,
      };
      this.chengyuan.push(obj);

      this.mmmm = false;
      this.show = false;
    },

    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
  },
};
</script>

<style lang="less" scoped>
.jtcy {
  padding: 15px;
  .tj {
    height: 40px;
    width: 100%;
    background-color: rgba(187, 218, 246, 0.5);
    border: 1px dashed #49a3f1;
    border-radius: 5px;
    padding-left: 15px;
    .ziti1 {
      display: inline-block;

      font-size: 13px;
      color: #49a3f1;
      margin-left: 5px;
      position: absolute;
      margin-top: 12px;
    }
    .cvb {
      display: inline-block;
      line-height: 40px;
    }
  }
  .asd12 {
    color: #a5a5a5;
  }
  .chengyuan {
    background-color: #fff;
    width: 69px;
    width: 100%;
    font-size: 13px;
    padding: 10px 5px;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .user {
      width: 35%;
      height: 30px;
      line-height: 25px;
    }
    .guanxi {
      width: 65%;
      height: 18px;
      line-height: 25px;
    }
    .age {
      width: 35%;
      height: 18px;
      line-height: 25px;
    }
    .sj {
      width: 65%;
      height: 18px;
      line-height: 25px;
    }
    .anniu {
      display: inline-block;
      position: absolute;
      right: 2px;
      top: 0px;
      width: 50px;
      height: 17px;
      font-size: 10px;
      background-color: #dcdcdc;
      border-radius: 4px;
      color: #aeabab;
      border: none;
    }
  }
}
.mmm {
  position: absolute;
  top: 25%;
  left: 5%;
  margin: 0 auto;
  z-index: 9999999;
  width: 90%;
}

.tanc {
  width: 100%;
  box-shadow: 1px 1px 1px 1px #d7d7d7;
  padding: 10px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
}
.bbt {
  display: inline-block;
  color: #ffad0e;
  font-size: 20px;
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
}

.btn{
    width: 60%;
  height: 30px;
  margin: auto;
}
.btn1 {
  display: inline-block;
  width: 100%;
  height: 30px;
  border-radius: 20px;
  border: none;
  background: -webkit-linear-gradient(left, #f39a70, #fe8148);
  margin: auto;
  color: white;
  font-size: 17px;
}
.gb {
  position: absolute;
  right: 1px;
  top: 1px;
}
</style>